import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=45bfddf4&scoped=true"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"
import style0 from "./connect.vue?vue&type=style&index=0&id=45bfddf4&prod&scoped=true&lang=css"
import style1 from "./connect.vue?vue&type=style&index=1&id=45bfddf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bfddf4",
  null
  
)

export default component.exports